import React from 'react';
import { Box, Typography, Container, Grid, Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/GetApp';
import StarIcon from '@mui/icons-material/Star';
import { motion } from 'framer-motion';

const AppDownload = () => {
  const royalGoldenGradient = "linear-gradient(135deg, #8B4513 0%, #B8860B 50%, #FFD700 100%)";

  return (
    <Box sx={{ 
      py: { xs: 6, md: 10 }, 
      background: royalGoldenGradient, 
      position: 'relative', 
      overflow: 'hidden',
      color: '#fff'
    }}>
      
      {/* बॅकग्राउंड ॲनिमेटेड स्टार्स */}
      <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: 0.15, zIndex: 0 }}>
        <StarIcon sx={{ position: 'absolute', top: '15%', left: '10%', fontSize: '20px' }} />
        <StarIcon sx={{ position: 'absolute', top: '40%', left: '85%', fontSize: '25px' }} />
        <StarIcon sx={{ position: 'absolute', top: '80%', left: '25%', fontSize: '15px' }} />
      </Box>

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Grid container spacing={4} alignItems="center" justifyContent="center">
          
          {/* --- डावी बाजू: मजकूर --- */}
          <Grid item xs={12} md={6}>
            <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
              <motion.div 
                initial={{ opacity: 0, y: 20 }} 
                whileInView={{ opacity: 1, y: 0 }} 
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              >
                <Typography variant="overline" sx={{ color: '#fff', fontWeight: 800, letterSpacing: 2, bgcolor: 'rgba(0,0,0,0.15)', px: 2, py: 0.5, borderRadius: '4px', fontSize: '0.75rem' }}>
                  आध्यात्मिक क्रांती
                </Typography>
                <Typography variant="h2" sx={{ 
                  fontWeight: 800, 
                  fontFamily: "'serif'", 
                  mb: 2, mt: 2,
                  fontSize: { xs: '1.8rem', md: '2.8rem' },
                  lineHeight: 1.2
                }}>
                  भक्तीचा <span style={{ color: '#4E342E' }}>डिजिटल</span> <br /> मार्ग आता सुलभ
                </Typography>
                <Typography variant="body1" sx={{ opacity: 0.9, mb: 4, fontSize: { xs: '0.95rem', md: '1.05rem' }, lineHeight: 1.7, maxWidth: {xs: '100%', md: '450px'} }}>
                  केवळ एका स्पर्शाने अनुभवा शुद्ध भक्ती. सर्व पूजाविधी, मंत्र आणि भक्ती संगीत आता तुमच्या सदैव सोबत. आजच डाऊनलोड करा.
                </Typography>

                {/* अपडेट केलेले डाऊनलोड बटण */}
                <Button 
                  variant="contained" 
                  startIcon={<DownloadIcon />}
                  component="a" 
                  href="/apk/JinbhaktiApp(06-04-2026).apk" 
                  download="JinbhaktiApp.apk" 
                  sx={{ 
                    bgcolor: '#4E342E', color: '#fff', px: 5, py: 1.5, borderRadius: '50px',
                    fontWeight: 'bold', fontSize: '1rem',
                    '&:hover': { bgcolor: '#3E2723' },
                    boxShadow: '0 8px 25px rgba(0,0,0,0.2)', textTransform: 'none',
                    display: 'inline-flex'
                  }}
                >
                  ॲप डाऊनलोड करा
                </Button>
              </motion.div>
            </Box>
          </Grid>

          {/* --- उजवी बाजू: Digital Aura --- */}
          <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: 'center', mt: { xs: 4, md: 0 } }}>
            <Box style={{ position: 'relative', width: 'fit-content', height: 'fit-content' }}>
              
              <motion.div 
                animate={{ rotate: 360 }}
                transition={{ repeat: Infinity, duration: 15, ease: "linear" }}
              >
                <Box sx={{ 
                  width: { xs: '240px', md: '340px' }, 
                  height: { xs: '240px', md: '340px' }, 
                  border: '2px dashed rgba(255,255,255,0.4)',
                  borderRadius: '50%',
                }} />
              </motion.div>

              <Box sx={{ 
                position: 'absolute',
                top: '50%', left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '80%', height: '80%', 
                background: 'rgba(255,255,255,0.12)',
                backdropFilter: 'blur(12px)',
                borderRadius: '50%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid rgba(255,255,255,0.3)',
                boxShadow: '0 0 40px rgba(255,255,255,0.15)',
                zIndex: 2
              }}>
                <motion.div
                  animate={{ scale: [1, 1.05, 1] }}
                  transition={{ repeat: Infinity, duration: 4 }}
                  style={{ textAlign: 'center' }}
                >
                  <Typography variant="h2" sx={{ fontWeight: 900, color: '#fff', fontSize: { xs: '3rem', md: '4rem' } }}>ॐ</Typography>
                  <Typography variant="h6" sx={{ fontWeight: 800, mt: -1, letterSpacing: 1.5, fontSize: { xs: '1rem', md: '1.25rem' } }}>जिनभक्ती</Typography>
                  <Typography variant="caption" sx={{ opacity: 0.8, display: 'block' }}>Official App</Typography>
                </motion.div>
              </Box>
            </Box>
          </Grid>

        </Grid>
      </Container>
    </Box>
  );
};

export default AppDownload;